/* unplugin-vue-components disabled */import script from "./maskLayer.vue?vue&type=script&setup=true&lang=js"
export * from "./maskLayer.vue?vue&type=script&setup=true&lang=js"

import "./maskLayer.vue?vue&type=style&index=0&id=3e13bbad&lang=css"

const __exports__ = script;

export default __exports__